"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _classnames = _interopRequireDefault(require("classnames"));

var _HTMLContent = _interopRequireDefault(require("../common/HTMLContent"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var CustomHeader = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(CustomHeader, _Component);

  var _super = _createSuper(CustomHeader);

  function CustomHeader() {
    (0, _classCallCheck2.default)(this, CustomHeader);
    return _super.apply(this, arguments);
  }

  (0, _createClass2.default)(CustomHeader, [{
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return nextProps.html !== this.props.html;
    }
  }, {
    key: "render",
    value: function render() {
      var html = this.props.html;
      return (0, _preact.h)(_HTMLContent.default, {
        html: html,
        className: (0, _classnames.default)(['ssi', 'ssi-header', 'custom-header'])
      });
    }
  }]);
  return CustomHeader;
}(_preact.Component);

var _default = CustomHeader;
exports.default = _default;